import { writable } from "svelte/store";

/**
 * Store that signals when a new chat should be started.
 * Components can increment this value to trigger a new chat.
 * The chat component watches this and calls restartChat when it changes.
 */
const store = writable(0);
const { subscribe, update } = store;

export const newChatSignal = {
  subscribe,
  /**
   * Signal that a new chat should be started.
   * This increments the counter, which the chat component watches.
   */
  trigger: () => update((n) => n + 1),
};
